export default __webpack_public_path__ + "static/media/p2.3c3ad94b.png";